const MAX_DELAY = 200;
const MAX_RETRIES = 5;

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * Retry the given function until it resolves successfully. Handles both
 * synchronous throws and async rejections. Rejects with the final error after
 * exhausting retries.
 */
export const retry = async <T>(
  fn: () => T | Promise<T>,
  onRetriesCompleted: () => void = () => { },
  retriesLeft: number = MAX_RETRIES,
  delay: number = MAX_DELAY,
): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    if (retriesLeft > 0) {
      await sleep(delay);
      return retry(fn, onRetriesCompleted, retriesLeft - 1, delay);
    }
    onRetriesCompleted();
    throw error;
  }
};
